module.exports = __webpack_public_path__ + "img/slim28.a42a6cae.jpg";